import request from 'axios';
import { getWxUtil } from './wx_mp';

export function url(cgi, withProtocol = false) {
  return `${withProtocol ? 'https:' : ''}//fudao.qq.com${cgi}`;
}

// 校验短信验证码
export function verifySmsCode(phone, code, type) {
  return new Promise((resolve, reject) => {
    request
      .get(url('/cgi-proxy/mobile/check_verify_code'), {
        params: {
          app_id: 'k12',
          scene: 'k12_login',
          nation_code: '86',
          phone_number: phone,
          platform: 'web',
          code_type: type,
          verify_code: code,
        },
      })
      .then(response => {
        const {
          data: { retcode },
        } = response;

        if (retcode !== 0) {
          return resolve(false);
        }

        return resolve(true);
      })
      .catch(e => {
        console.error(e);
        reject(`校验验证码错误：${e.toString()}`);
      });
  });
}

// 上报crm
export function postCRM(data) {
  return request.get(
    url('/cgi-proxy/k12_activity/ad_distribute/save_ad_distribute'),
    {
      params: data,
    }
  );
}

// 转介绍留咨
export function postCRMTransferIntro(data) {
  return request.get(url('/cgi-proxy/crm_intro/subscribe_userinfo_live_app'), {
    params: data,
  });
}

export function wxNoPasswdPhoneLogin(data) {
  return getWxUtil('request')({
    url: url('/cgi-bin/uidaccount/k12/wx_sa_login', true),
    method: 'POST',
    data: {
      ...data,
      appId: 'wx36ed58457a087ec8',
      buzId: 122051800,
    },
    // enableSetCookie: true,
    // caseInsensitiveHeader: true,
  });
}
